export const StyleUtil = {
  mergeClassNames: (classNames: string[]): string => classNames.join(' '),
};
